import FormError from 'components/form-error/form-error.component';

const SpreedlyGlobalErrors = ({ errorObj = {} }) => {
  const error = Object.values(errorObj)[0] ?? {};

  if (!error.key) return null;

  return <FormError errorMessage={error.message} />;
};

export default SpreedlyGlobalErrors;
